import React from 'react';

export function ProjectEquipmentUtilization() {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Hiệu suất thiết bị</h3>
        <button className="text-xs font-normal text-blue-600 hover:underline">Chi tiết</button>
      </div>

      <div className="space-y-4">
        <div className="space-y-1">
           <p className="text-xs font-normal text-slate-400">Tỷ lệ sử dụng trung bình</p>
           <p className="text-2xl font-normal text-slate-900">72%</p>
        </div>
        
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
           <div className="h-full bg-emerald-500" style={{ width: '72%' }} />
        </div>

        <div className="flex items-center gap-1.5 text-xs font-normal text-emerald-600 bg-emerald-50 w-fit px-2 py-0.5 rounded-md">
           <i className="ri-arrow-up-line" />
           <span>Tăng 8% so với tháng trước</span>
        </div>
      </div>
    </div>
  );
}
